import { ApiConfig } from 'common/models';
import { MAIN_ROUTES } from 'common/config';
import { HttpHeader } from 'common/enums/api-status.enum';
import { msalInstance, protectedResources } from 'common/config/auth.config';
import { BaseHTTPClient } from './base-http-client.service';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

export abstract class HttpClient extends BaseHTTPClient {
    protected static async invokeApi<T>(apiConfig: ApiConfig) {
        let result;
        await msalInstance
            .acquireTokenSilent({
                scopes: protectedResources.api.scopes
            })
            .then((tokenResponse) => {
                result = this.callApi<T>(apiConfig, tokenResponse.idToken);
            })
            .catch((error) => {
                if (error instanceof InteractionRequiredAuthError) {
                    msalInstance
                        .acquireTokenPopup({
                            scopes: protectedResources.api.scopes
                        })
                        .then((accessTokenResponse) => {
                            // Acquire token interactive success
                            const accessToken = accessTokenResponse.idToken;
                            // Call your API with token
                            result = this.callApi<T>(apiConfig, accessToken);
                        })
                        .catch(function (error) {
                            // Acquire token interactive failure
                            window.location.href = MAIN_ROUTES.UNAUTHORIZED;
                        });
                }
            });
        return result;
    }

    private static async callApi<T>(apiConfig: ApiConfig, token: string) {
        let result;
        const header = {
            [HttpHeader.AUTHORIZATION]: `Bearer ${token}`,
            ...apiConfig.header
        };
        const baseUrl = apiConfig.baseUrl ? apiConfig.baseUrl : protectedResources.api.endpoint;
        switch (apiConfig.method) {
            case 'GET': {
                const url =
                    baseUrl +
                    apiConfig.url +
                    (apiConfig.queryString ? `?${apiConfig.queryString}` : '');
                result = await this.get<T>(url, header);
                break;
            }
            case 'POST': {
                result = await this.post<T>(
                    baseUrl +
                        apiConfig.url +
                        (apiConfig.queryString ? `?${apiConfig.queryString}` : ''),
                    apiConfig.data,
                    header,
                    apiConfig.additionalConfig
                );
                break;
            }
            case 'PATCH':
                result = await this.patch<T>(baseUrl + apiConfig.url, apiConfig.data, header);
                break;
            case 'PUT':
                result = await this.put<T>(baseUrl + apiConfig.url, apiConfig.data, header);
                break;
            case 'DELETE': {
                result = await this.delete<T>(baseUrl + apiConfig.url, apiConfig.data, header);
                break;
            }
        }
        return result;
    }
}
